import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HomeComponent} from './home.component';
import {TranslateModule} from '@ngx-translate/core';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {LoginComponent} from './login/login.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {HomeRoutingModule} from './home-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NzGridModule} from 'ng-zorro-antd/grid';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {FormatTimePipe} from '../pipes/format-time.pipe';
import {BoldPipe} from '../pipes/bold-word-in-quote.pipe';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzSpinModule} from 'ng-zorro-antd/spin';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {NgxMaskModule} from 'ngx-mask';
import {NgxKjuaModule} from 'ngx-kjua';
import {NzNotificationModule} from 'ng-zorro-antd/notification';
import {QrLoginComponent} from './login/qr-login/qr-login.component';
import {CompanySwitcher} from '../portal/header/company-switcher.service';
import {NzMessageModule} from 'ng-zorro-antd/message';
import {FaqComponent} from './login/faq/faq.component';
import {GetAppFaqComponent} from './login/get-app-faq/get-app-faq.component';
import {FaqContentComponent} from './login/faq/faq-content/faq-content.component';
import { SiteAssociationComponent } from './site-association/site-association.component';
import { SiteAssociationService } from './site-association/site-association.service';
import { FaqService } from './login/faq/services/faq.service';
import { PipesModule } from '@shared/pipes.module';
import { SafetyMeasuresModule } from '@shared/safety-measures.module';

@NgModule({
  declarations: [
    HomeComponent,
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    FormatTimePipe,
    BoldPipe,
    QrLoginComponent,
    FaqComponent,
    GetAppFaqComponent,
    FaqContentComponent,
    SiteAssociationComponent,
  ],
  exports: [
    LoginComponent,
    QrLoginComponent
  ],
  imports: [
    HomeRoutingModule,
    CommonModule,
    TranslateModule,
    NzButtonModule,
    NzSelectModule,
    FormsModule,
    NzGridModule,
    NzInputModule,
    NzIconModule,
    NzTabsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzSpinModule,
    NgxKjuaModule,
    NzNotificationModule,
    NzMessageModule,
    NzModalModule,
    NgxMaskModule.forRoot(),
    PipesModule,
    SafetyMeasuresModule
  ],
  providers: [
    CompanySwitcher,
    SiteAssociationService,
    FaqService
  ]
})
export class HomeModule {
}
